<template>
    <div id="app" class="page" :class="mainColor">
        <themePenal />
        <!-- background -->
        <div class="background gradient">
            <ul class="bg-bubbles">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
            </ul>
        </div>

        <!--
			Container
        -->
        <div class="container opened" :class="{'dark':isDark}" data-animation-in="fadeInLeft" data-animation-out="fadeOutLeft">
            <header class="header">
                <div class="top-menu">
                    <ul>
                        <li v-for="(item, index) in routerList" :key="index" :class="{'active':item.link==$route.name}">
                            <a @click="$router.push({name:item.link})">
                                <span :class="item.icon"></span>
                                <span class="link" v-text="item.name"></span>
                            </a>
                        </li>
                    </ul>
                </div>
            </header>
            <Main />
            <transition :name="pageAni">
                <router-view />
            </transition>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import Main from "@/components/Main";
import themePenal from "@/components/themePenal";

export default {
    name: "App",
    data() {
        return {};
    },
    computed: {
        ...mapState(["pageAni", "mainColor", "isDark"]),
        routerList() {
            return [
                { link: "AboutMe", icon: "icon ion-person", name: this.$t("app.001") },
                { link: "Resume", icon: "icon ion-android-list", name: this.$t("app.002") },
                { link: "Works", icon: "icon ion-paintbrush", name: this.$t("app.003") },
                { link: "Blog", icon: "icon ion-icecream", name: this.$t("app.004") },
                { link: "Contact", icon: "icon ion-at", name: this.$t("app.005") }
            ];
        }
    },
    components: { Main, themePenal }
};
</script>

<style lang="scss">
@charset "UTF-8";
@import "@/assets/scss/all.scss";
@import "@/assets/scss/style.scss";
@import "@/assets/scss/colortemp/dark.scss";
@import "animate.css";
body.swal2-height-auto.swal2-iosfix {
    height: 100% !important;
}
@mixin lower1024() {
    @media only screen and (max-width: 1023px) {
        @content;
    }
}

.rotate-enter-active {
    animation: rotateInDownLeft 0.8s;
    @include lower1024() {
        animation: fadeInDown 0.8s;
    }
}
.rotate-leave-active {
    animation: rotateOutDownLeft 0.8s;
    @include lower1024() {
        animation: fadeOutUp 0.8s;
    }
}
.slide-enter-active {
    animation: slideInLeft 0.5s;
    @include lower1024() {
        animation: fadeInDown 0.8s;
    }
}
.slide-leave-active {
    animation: slideOutLeft 0.5s;
    @include lower1024() {
        animation: fadeOutUp 0.8s;
    }
}

.flip-enter-active {
    animation: flipInX 1s;
    @include lower1024() {
        animation: fadeInDown 0.8s;
    }
}
.flip-leave-active {
    animation: flipOutX 1s;
    @include lower1024() {
        animation: fadeOutUp 0.8s;
    }
}

.roll-enter-active {
    animation: rollIn 1s;
    @include lower1024() {
        animation: fadeInDown 0.8s;
    }
}
.roll-leave-active {
    animation: rollOut 1s;
    @include lower1024() {
        animation: fadeOutUp 0.8s;
    }
}
.fade-enter-active {
    animation: fadeInDown 1s;
}
.fade-leave-active {
    animation: fadeOutUp 1s;
}

.gm-control-active {
    > img {
        box-sizing: content-box;
        display: none;
        left: 50%;
        pointer-events: none;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        &:nth-child(1) {
            display: block;
        }
    }
    &:hover > img:nth-child(1),
    &:active > img:nth-child(1) {
        display: none;
    }
    &:hover > img:nth-child(2),
    &:active > img:nth-child(3) {
        display: block;
    }
}

.gm-ui-hover-effect {
    opacity: 0.6;
    &:hover {
        opacity: 1;
    }
}

.gm-style {
    .gm-style-cc {
        span,
        a {
            font-size: 10px;
            box-sizing: border-box;
        }
    }
    .gm-style-mtc div {
        font-size: 10px;
        box-sizing: border-box;
    }
}

@media print {
    .gm-style .gmnoprint,
    .gmnoprint {
        display: none;
    }
}

@media screen {
    .gm-style .gmnoscreen,
    .gmnoscreen {
        display: none;
    }
}

.gm-style-pbc {
    transition: opacity ease-in-out;
    background-color: rgba(0, 0, 0, 0.45);
    text-align: center;
}

.gm-style-pbt {
    font-size: 22px;
    color: white;
    font-family: Roboto, Arial, sans-serif;
    position: relative;
    margin: 0;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
}

.gm-style {
    img {
        max-width: none;
    }
    font: 400 11px Roboto, Arial, sans-serif;
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue